import { useCallback, useEffect, useRef, useState } from "react";
import { Camera, Send } from "lucide-react";
import { toast } from "sonner";
import { techApi, techErr, techFile, fmtWIB } from "../../lib/teknisiApi";
import { playNotify } from "../../lib/notifySound";
import { ZoomImg } from "../../components/ZoomImg";

export default function TeknisiChat() {
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);
  const fileRef = useRef(null);
  const countRef = useRef(null);
  const load = useCallback(() => techApi.get("/my/chat").then((r) => {
    if (countRef.current !== null && r.data.length > countRef.current && r.data[r.data.length - 1]?.from !== "tech") playNotify();
    countRef.current = r.data.length; setMsgs(r.data);
  }).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [load]);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs.length]);
  const send = async (e) => {
    e.preventDefault(); if (!text.trim()) return;
    try { await techApi.post("/my/chat", { text }); setText(""); load(); } catch (err) { toast.error(techErr(err)); }
  };
  const sendPhoto = async (e) => {
    const f = e.target.files?.[0]; e.target.value = ""; if (!f) return;
    setBusy(true);
    const fd = new FormData(); fd.append("photo", f); fd.append("caption", text);
    try { await techApi.post("/my/chat/photo", fd); setText(""); load(); } catch (err) { toast.error(techErr(err)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-col h-[calc(100vh-9.5rem)]" data-testid="teknisi-chat">
      <h2 className="font-extrabold text-[#0f2a6b] mb-2">Chat Admin Fasnet</h2>
      <div className="flex-1 overflow-y-auto space-y-2 rounded-2xl bg-white p-3 shadow-sm">
        {!msgs.length && <div className="text-xs text-slate-500 text-center py-8">Belum ada pesan. Tanyakan kendala pekerjaan ke admin di sini.</div>}
        {msgs.map((m) => (
          <div key={m.id} className={`flex ${m.from === "tech" ? "justify-end" : "justify-start"}`} data-testid={`teknisi-chat-msg-${m.id}`}>
            <div className={`max-w-[85%] rounded-2xl px-3 py-2 text-sm ${m.from === "tech" ? "bg-[#0f2a6b] text-white rounded-br-sm" : m.system ? "bg-amber-50 border border-amber-300 text-amber-900 rounded-bl-sm" : "bg-slate-100 rounded-bl-sm"}`}>
              <div className={`text-[11px] font-extrabold mb-0.5 ${m.from === "tech" ? "text-blue-100" : m.system ? "text-amber-700" : "text-[#F04E23]"}`}>{m.name}{m.from === "tech" ? " (Anda)" : m.system ? "" : " · Admin"}</div>
              {m.image_path && <ZoomImg src={techFile(m.image_path)} alt="foto chat" className="rounded-lg max-h-56 mb-1" data-testid={`teknisi-chat-img-${m.id}`} />}
              {m.text && <div className="whitespace-pre-wrap break-words">{m.text}</div>}
              <div className={`text-[9px] mt-0.5 ${m.from === "tech" ? "text-blue-200 text-right" : "text-slate-400"}`}>{fmtWIB(m.created_at)}</div>
            </div>
          </div>
        ))}
        <div ref={endRef} />
      </div>
      <form onSubmit={send} className="flex gap-2 pt-2">
        <input ref={fileRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={sendPhoto} data-testid="teknisi-chat-photo-input" />
        <button type="button" disabled={busy} onClick={() => fileRef.current?.click()} className="h-11 w-11 rounded-xl bg-white border border-slate-300 text-slate-600 flex items-center justify-center disabled:opacity-60" title="Kirim foto" data-testid="teknisi-chat-photo"><Camera className="w-5 h-5" /></button>
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Tulis pesan / keterangan foto…" className="flex-1 h-11 rounded-xl border border-slate-300 px-3 text-sm bg-white" data-testid="teknisi-chat-input" />
        <button type="submit" className="h-11 w-11 rounded-xl bg-[#F04E23] text-white flex items-center justify-center" data-testid="teknisi-chat-send"><Send className="w-5 h-5" /></button>
      </form>
    </div>
  );
}
